/* istanbul ignore file */

import { MapIcon } from './map-pin-model';

export class KhThemeServiceModel {
    mapIcon: MapIcon | null;
}
